import React, { Component } from 'react';
import ReportsController from './reports.controller';
import withHooks from '../../core/withHooks';
import Inherit from '../../core/inherit';
import { Layout, Title } from '../common';
import { TeamOutlined, DollarOutlined } from '@ant-design/icons';
import ReportsUsersTable from './elements/ReportsUsersTable';
import ReportsTransactionsTable from './elements/ReportsTransactionsTable';
import ReportsUsersTableActions from './elements/ReportsUsersTableActions';
import ReportsTransactionsTableActions from './elements/ReportsTransactionsTableActions';
import styles from './styles/reports.module.scss';

class Reports extends Inherit(ReportsController, Component) {
    state = {
        user: {},
        loading: true,
        users: [],
        usersRows: [],
        ledger: {},
        transactionsRows: [],
        activeTab: 'users',
        filters: {
            timeFrame: 'all',
            dateRange: null,
            enrollment: 'enrolled',
            hasCompleteDDSwitch: null,
        },
    };

    handleTabChange = (tabKey) => {
        this.setActiveTab(tabKey);
    };

    render() {
        const { user, loading, users, usersRows, transactionsRows, activeTab, filters } = this.state;

        const tabs = [
            {
                key: 'users',
                label: 'Users',
                icon: <TeamOutlined />,
                component: (
                    <div className={styles.contentWrapper}>
                        <ReportsUsersTable 
                            rows={usersRows} 
                            loading={loading} 
                            navigateUser={this.navigateUser.bind(this)} 
                        />
                    </div>
                )
            },
            {
                key: 'transactions',
                label: 'Transactions',
                icon: <DollarOutlined />,
                component: (
                    <div className={styles.contentWrapper}>
                        <ReportsTransactionsTable 
                            rows={transactionsRows} 
                            loading={loading} 
                        />
                    </div>
                )
            }
        ];

        const activeTabData = tabs.find(tab => tab.key === activeTab);

        return (
            <Layout user={user} fi={user?.fi?.name}>
                <Title title="Reports" />
                
                <div className={styles.tabsContainer}>
                    <div className={styles.tabsHeader}>
                        {tabs.map(tab => (
                            <button
                                key={tab.key}
                                className={`${styles.tab} ${activeTab === tab.key ? styles.active : styles.inactive}`}
                                onClick={() => this.handleTabChange(tab.key)}
                            >
                                <span className={styles.tabIcon}>{tab.icon}</span>
                                <span className={styles.tabLabel}>{tab.label}</span>
                            </button>
                        ))}
                    </div>
                    
                    {activeTab === 'users' && (
                        <ReportsUsersTableActions
                            setRows={this.setRows.bind(this)}
                            users={users}
                            handleFilterChange={this.handleFilterChange.bind(this)}
                            resetFilters={this.resetFilters.bind(this)}
                            applyFilters={this.applyFilters.bind(this)}
                            handleTimeFrameChange={this.handleTimeFrameChange.bind(this)}
                            handleDateRangeChange={this.handleDateRangeChange.bind(this)}
                            loading={loading}
                            filters={filters}
                            rows={usersRows}
                        />
                    )}

                    {activeTab === 'transactions' && (
                        <ReportsTransactionsTableActions
                            ledger={transactionsRows}
                            setRows={this.setRows.bind(this)}
                            rows={transactionsRows}
                        />
                    )}
                    
                    <div className={styles.tabContent}>
                        {activeTabData?.component}
                    </div>
                </div>
            </Layout>
        );
    }
}

export default withHooks(Reports);

